import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './tellent-auth-migration.component.less'],
  templateUrl: './tellent-auth-migration.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    EmailMailgunIfDirective,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentAuthMigrationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentAuthMigrationTemplateData>;
}

export type TellentAuthMigrationTemplateData = {
  title: string;
  p1: string;
  p2_1_html: string;
  p2_2_html: string;
  p3: string;
  help_center_url: string;
  log_in_link: {
    label: string;
    href: string;
  };
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const TellentAuthMigrationTemplateMocks: TellentAuthMigrationTemplateData[] = [
  {
    title: 'New login experience',
    p1: `We've simplified the login process for you. From now on, whether you're using one app or both of them, you'll only need to log in through a single page for:`,
    p2_1_html: `<b>Recruitee (ATS)</b>`,
    p2_2_html: `<b>KiwiHR (HRIS)</b>`,
    p3: 'Visit our help center to learn more:',
    help_center_url: 'https://support.recruitee.com/en/articles/9638762-new-login-page',
    log_in_link: {
      label: 'Log in',
      href: 'https://auth.tellent.com',
    },
    footer: {
      text: 'Need help?',
      href: 'https://auth.tellent.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
  },
];
